module.exports = require("readline");


//////////////////
// WEBPACK FOOTER
// external "readline"
// module id = 530
// module chunks = 0